var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyWaladCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 206,
    viewBox: "0 0 149 206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5020",
    "data-name": "Group 5020",
    transform: "translate(-701 -357)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "CARTE",
    width: 149,
    height: 206,
    rx: 74.5,
    transform: "translate(701 357)",
    fill: "#c39745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8346",
    "data-name": "Path 8346",
    d: "M11.914,29.039l.106-.847a9.845,9.845,0,0,1,2.595-7.2,12.635,12.635,0,0,1,5.666-3.5,16.208,16.208,0,0,0,5.666-2.86,6.537,6.537,0,0,0,2.595-5.454,7.118,7.118,0,0,0-1.959-5.349Q24.623,1.926,20.7,1.926T14.932,3.144a5.26,5.26,0,0,0-2.277,2.489L12.338,6.9a12.415,12.415,0,0,1-2.224,4.183,4.19,4.19,0,0,1-3.283,1.43,15.6,15.6,0,0,1-5.3-1.271Q-4.82,8.81-4.82,5.209a8.907,8.907,0,0,1,.635-3.23Q-3.549.337-3.125-.775A23.859,23.859,0,0,1-.848-4.641,24.256,24.256,0,0,1,3.388-9.46a23.964,23.964,0,0,1,6.725-3.813,25.6,25.6,0,0,1,9.638-1.748q11.227,0,18.323,7.2a23.119,23.119,0,0,1,7.1,16.734,21.319,21.319,0,0,1-1.642,8.42,18.04,18.04,0,0,1-3.972,6.09,26.431,26.431,0,0,1-8.685,5.931l-1.695.53a17.947,17.947,0,0,1-.159,2.754,5.092,5.092,0,0,1-.953,2.065,4.474,4.474,0,0,1-2.648,1.589,20.476,20.476,0,0,1-4.925.477,18.51,18.51,0,0,1-4.925-.53,4.145,4.145,0,0,1-2.595-1.8,6.743,6.743,0,0,1-.9-2.277A22.068,22.068,0,0,1,11.914,29.039ZM11.49,48a4.965,4.965,0,0,1,3.018-2.436,22.9,22.9,0,0,1,6.831-.741q4.66,0,6.725,2.065t2.065,8a14.378,14.378,0,0,1-1.059,6.3,5.313,5.313,0,0,1-3.23,2.754,24.048,24.048,0,0,1-6.725.688q-4.554,0-6.99-2.224-1.8-1.8-1.8-6.143V54.563a32.221,32.221,0,0,1,.159-3.707A8.452,8.452,0,0,1,11.49,48Z",
    transform: "translate(755.324 435.197)",
    fill: "#eac676"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWaladCard);
export default __webpack_public_path__ + "static/media/empty_walad_card.2ed355fd.svg";
export { ForwardRef as ReactComponent };